export const Loader = ({loading}) => {
    return (
        <div className={`sw-loader sw-loader_overlay ${loading ? "-visible" : ""}`}/>
    );
};
